exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-edit-button{\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n.image-edit-button.btn-outline-light{\n    color: #ddd;\n    border-color: #ddd;\n}\n.editableimage-upload label[for=\"editableimage\"]{\n  position: relative;\n}\n.editableimage-wrap img {\n  display: block;\n  /* This rule is very important, please don't ignore this */\n  max-width: 100%;\n}\n.file-uploads{\n  min-width: 160px;\n}\n", ""]);

// exports
